import { Button, Grid } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const ButtonOpenAnotherTab = (props) => {
  const { handleClick, tabItem } = props;

  return (
    <Grid
      container
      direction="column"
      justify="center"
      style={{ position: "absolute", margin: "auto", minHeight: "calc(100% - 85px)" }}
    >
      <Grid item style={{ margin: "auto" }}>
        <Button color={"primary"} variant="contained" onClick={handleClick(tabItem.sourceUrl)}>
          {" "}
          Open document in a another Window{" "}
        </Button>
      </Grid>
    </Grid>
  );
};

ButtonOpenAnotherTab.propTypes = {
  handleClick: PropTypes.func,
  tabItem: PropTypes.object,
};

export default ButtonOpenAnotherTab;
